import Form from "./Form";
import { getResponsibilityFields } from "../utils";
import { useDataContext } from "../contexts";

export default function ResponsibilityEdit({ callback, id }) {
  const { memberUsers, getResponsibilityById } = useDataContext();

  const responsibility = getResponsibilityById(id);

  if (!responsibility) {
    return "Responsibility not found";
  }

  const responsibilityFields = getResponsibilityFields(memberUsers);

  return (
    <Form
      path="responsibilities"
      id={responsibility.id}
      method="PATCH"
      submitCallback={callback}
      initialValues={responsibility}
      fields={responsibilityFields}
    />
  );
}
